import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import { AiFillGithub, AiOutlineMail, AiFillPhone } from "react-icons/ai";

function Home2() {
  const email = "vladyslavstoliarov@gmail.com";
  const phone = "+380 966767809";
  const [message, setMessage] = useState("");

  const handleSendEmail = (e) => {
    e.preventDefault();
    if (message.trim() === "") return;
    const mailtoLink = `mailto:${email}?subject=Message%20from%20Portfolio&body=${encodeURIComponent(message)}`;
    window.location.href = mailtoLink;
  };

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={9} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              <span className="yellow"> BRIEF INTRODUCTION </span>
            </h1>
            <p className="home-about-body">
              I’m a passionate Full Stack & AI Developer specializing in
              <br />
              <i>
                <b className="purple"> AI chatbots, RAG, LLM, and web automation. </b>
              </i>
              <br />
              <br />
              With expertise in <b className="purple"> React, Next.js, Node.js, and Python, </b>
              I build scalable &nbsp;
              <i>
                <b className="purple"> SaaS platforms and AI-powered applications </b>
              </i>
              &nbsp; that transform business operations.
              <br />
              <br />
              Let’s turn your
              <i>
                <b className="purple"> ideas </b>
              </i>
              &nbsp; into reality with cutting-edge tech and clean, reliable code!
            </p>
          </Col>
          <Col md={3} className="myAvtar">
            <img src={myImg} className="img-fluid tech-icons" alt="avatar" style={{ width: "60%" }} />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>

            <ul className="home-about-social-links" style={{ listStyleType: "none", padding: 0 }}>
              <li style={{ display: "inline-block", marginRight: "20px" }}>
                <a
                  href="https://github.com/novasiliver"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub size={30} />
                </a>
              </li>
              <li style={{ display: "inline-block", marginRight: "20px" }}>
                <a href={`mailto:${email}`} className="icon-colour home-social-icons">
                  <AiOutlineMail size={30} />
                </a>
                <span className="purple" style={{ marginLeft: "8px" }}>{email}</span>
              </li>
              <li style={{ display: "inline-block" }}>
                <a href={`tel:${phone}`} className="icon-colour home-social-icons">
                  <AiFillPhone size={30} />
                </a>
                <span className="purple" style={{ marginLeft: "8px" }}>{phone}</span>
              </li>
            </ul>

            <div className="mt-4" style={{ maxWidth: "500px", margin: "0 auto" }}>
              <Form onSubmit={handleSendEmail}>
                <Form.Group controlId="messageInput">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Type your message here..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    style={{
                      backgroundColor: "#1a1a2e",
                      color: "#ffffff",
                      border: "1px solid #4b0082",
                      borderRadius: "8px",
                      padding: "10px",
                      resize: "none",
                    }}
                  />
                </Form.Group>
                <Button
                  type="submit"
                  style={{
                    backgroundColor: "#6a0dad",
                    borderColor: "#6a0dad",
                    color: "#fff",
                    marginTop: "15px",
                    borderRadius: "6px",
                    padding: "8px 20px",
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = "#8000ff")}
                  onMouseOut={(e) => (e.target.style.backgroundColor = "#6a0dad")}
                >
                  Send Message
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
